"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _OldButton = _interopRequireDefault(require("../OldButton"));

var _Box = _interopRequireDefault(require("../Box"));

var _Typography = _interopRequireDefault(require("../Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PickerCount(props) {
  let {
    data,
    add,
    remove
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Stack.default // direction="vertical"
  , {
    pl: "m"
  }, /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    bg: "primary.main",
    type: "circle-like",
    p: "s",
    onPress: () => {
      if (add) {
        add(data.id);
      }
    },
    disabled: data.loading || !props.add
  }, props.addIconRenderer), /*#__PURE__*/_react.default.createElement(_Box.default, {
    px: "m"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    ff: "mainBold"
  }, data.quantity)), /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    bg: "primary.main",
    type: "circle-like",
    p: "s",
    onPress: () => {
      if (remove) {
        remove(data.id);
      }
    },
    disabled: data.loading || !props.remove
  }, props.removeIconRenderer));
}

var _default = PickerCount;
exports.default = _default;